export const TAG_COLOR_OPTIONS = [
  "#64748b",
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#84cc16",
  "#22c55e",
  "#14b8a6",
  "#06b6d4",
  "#3b82f6",
  "#8b5cf6",
  "#d946ef",
  "#ec4899",
]

export const DEFAULT_TAG_COLOR = TAG_COLOR_OPTIONS[0]

export const getDefaultTagColor = (name: string) => {
  const normalized = name.trim()
  if (!normalized) return DEFAULT_TAG_COLOR
  const hash = Array.from(normalized).reduce(
    (value, char) => value + char.charCodeAt(0),
    0
  )
  return TAG_COLOR_OPTIONS[hash % TAG_COLOR_OPTIONS.length]
}
